import React from 'react';
import Grid from '@mui/material/Grid';
import PropTypes from 'prop-types';
import HeaderSearcherInput from '../../../../components/inputs/HeaderSearcherInput';
import RefreshButton from '../../../../components/buttons/RefreshButton';

const AvailableOffersFilters = ({
  finder,
  onRefresh,
  refreshLoading,
}) => (
  <>
    <Grid item xs={1.5} md={2.5} xl={1.8}>
      {onRefresh && (
        <RefreshButton
          onRefresh={onRefresh}
          loading={refreshLoading}
          id="available-offers-filters-refresh"
        />
      )}
    </Grid>
    <Grid item xs={10.5} md={4} xl={3}>
      <HeaderSearcherInput finder={finder} />
    </Grid>
  </>
);

AvailableOffersFilters.propTypes = {
  finder: PropTypes.shape({
    onFinderChange: PropTypes.func.isRequired,
    searchPlaceHolder: PropTypes.string.isRequired,
    finderValue: PropTypes.string.isRequired,
    canPasteExcel: PropTypes.bool,
    setColumnFilter: PropTypes.func,
  }),
  onRefresh: PropTypes.func,
  refreshLoading: PropTypes.bool,
};

AvailableOffersFilters.defaultProps = {
  finder: null,
  onRefresh: undefined,
  refreshLoading: false,
};

export default AvailableOffersFilters;
